<ion-content class="ion-padding">
  <div class="scroll-content-wo-padding">
    <ion-grid>
      <ion-text color="primary">
        <h6>
          <ion-icon name="checkmark-circle-outline"></ion-icon> {{
          'OrderConfirm.bekreftLevering' | translate }}
        </h6>
      </ion-text>

      <!-- Leveringsdato-bekreftelse: vises kun når planlagt dato != i dag -->
      <div class="delivery-date-confirm" *ngIf="dateMismatch">
        <div class="ddc-header">
          <ion-icon name="alert-circle"></ion-icon>
          <span>{{ 'OrderConfirm.deliveryDateTitle' | translate }}</span>
        </div>
        <p class="ddc-question">
          {{ 'OrderConfirm.deliveryDateQuestion' | translate:{ planned:
          plannedDateLabel, today: todayDateLabel } }}
        </p>
        <div class="ddc-options">
          <button
            type="button"
            class="ddc-option"
            [class.selected]="selectedDateOption === 'planned'"
            (click)="onDeliveryDateOptionChange('planned')"
          >
            <ion-icon
              class="ddc-check"
              [name]="selectedDateOption === 'planned' ? 'checkmark-circle' : 'ellipse-outline'"
            ></ion-icon>
            <span class="ddc-option-text">
              <small>{{ 'OrderConfirm.deliveryDatePlannedLabel' | translate }}</small>
              <strong>{{ plannedDateLabel }}</strong>
            </span>
          </button>
          <button
            type="button"
            class="ddc-option"
            [class.selected]="selectedDateOption === 'today'"
            (click)="onDeliveryDateOptionChange('today')"
          >
            <ion-icon
              class="ddc-check"
              [name]="selectedDateOption === 'today' ? 'checkmark-circle' : 'ellipse-outline'"
            ></ion-icon>
            <span class="ddc-option-text">
              <small>{{ 'OrderConfirm.deliveryDateTodayLabel' | translate }}</small>
              <strong>{{ todayDateLabel }}</strong>
            </span>
          </button>
        </div>
      </div>

      <div class="overflow-x">
        <div class="grid-width">
          <ion-row class="grid-header">
            <ion-col size-xs="3"
              >{{ 'OrdreDetails.produkt' | translate }}</ion-col
            >
            <ion-col size-xs="2"
              >{{ 'OrdreDetails.bestilt' | translate }}</ion-col
            >
            <ion-col size-xs="2"
              >{{ 'OrdreDetails.total' | translate }}</ion-col
            >
            <ion-col size-xs="3"
              >{{ 'Beholdning.depot' | translate }}</ion-col
            >
          </ion-row>
          <ion-row *ngFor="let orderLine of order.Orderlines">
            <ion-col size-xs="3">
              <div class="flex-parent">
                <span class="truncate-text">{{orderLine.Description}}</span>
              </div>
            </ion-col>
            <ion-col size-xs="2">
              <div class="inline-block bestilt">
                {{orderLine.Quantity}} /

                <span class="slight-big-font"
                  ><strong>{{orderLine.QuantityDelivered}}</strong></span
                >
              </div>
            </ion-col>

            <ion-col size-xs="2">{{ orderLine.OrderLineTotal}}</ion-col>
            
            <ion-col size-xs="3">
              <ion-select 
                [(ngModel)]="orderLine.DepotNo" 
                (ionChange)="onDepotChange(orderLine, $event.detail.value)"
                [placeholder]="'General.select' | translate"
                interface="popover">
                <ion-select-option *ngFor="let depot of depos" [value]="depot.DepotNo">
                  {{depot.Name}}
                </ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-row class="m-t-5">
            <ion-col size-xs="10" class="bigger-font ion-text-right">
              <ion-text color="black"
                ><b>{{'OrdreDetails.orderTotal' | translate }}</b
                >&nbsp;</ion-text
              >
            </ion-col>
            <ion-col size-xs="2" class="bigger-font">
              <ion-text color="black"><b>{{order.TotalOrder}}</b></ion-text>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-grid>
  </div>
</ion-content>
<ion-footer>
  <ion-buttons class="ion-float-right ion-margin">
    <ion-text color="danger" class="ion-margin-end" *ngIf="validationError">
      <strong>{{ validationError }}</strong>
    </ion-text>
    <ion-button
      (click)="validateAndDismiss(false)"
      color="grey"
      fill="outline"
      size="small"
    >
      <span>{{ 'General.avbryt' | translate }}</span>
    </ion-button>
    <ion-button (click)="validateAndDismiss(true)" fill="solid" size="small">
      <span>{{ 'General.save' | translate }}</span>
    </ion-button>
  </ion-buttons>
</ion-footer>
